import React, { useState, useEffect } from "react"
import { Redirect } from "react-router"
import PriceLevelService from "../../../state/price-level/PriceLevelService"
import PriceLevelForm from "../forms/PriceLevelForm"
import { injectIntl } from "react-intl"
import { EditPriceLevelProps } from "../../../common/types"
import { isError } from "../../../state/helpers/Error"
import SideBar from "../../../common/layout/sidebar.component"
import { useDispatch, useSelector } from "react-redux"
import { getPriceLevel } from "../../../state/price-level/PriceLevelSelector"
import { fetchPriceLevels, updatePriceLevelAction } from "../../../state/price-level/PriceLevelActions"
import { ProductPriceWithProductInfo } from "../../../common/types/productPrice/types"
import { createMultiProductPricePayload } from "../../../utils/product-price/utils"
import ProductPriceService from "../../../state/product-price/ProductPriceService"


const EditPriceLevelComponent = (props: EditPriceLevelProps) => {
    const [shouldRedirect, setShouldRedirect] = useState(false)
    const [error, setError] = useState("")
    const priceLevelIdMatch = props.match.params.priceLevelId
    const priceLevel = useSelector(state => getPriceLevel(state, priceLevelIdMatch))
    const dispatch = useDispatch()

    useEffect(() => {
        SideBar.activateMenu("product")
        if (!priceLevel) {
            dispatch(fetchPriceLevels())
        }
    }, [])

    const updatePriceLevel = (
        form: { name: string }, 
        productPricesWithProductInfo: ProductPriceWithProductInfo[], 
        saveWithRedirect: boolean
    ) => {
        setError("")
        if(productPricesWithProductInfo.some(item => !!item.recentlyModified)) {
            const payload = { "productPrices": createMultiProductPricePayload(productPricesWithProductInfo) }
            ProductPriceService.update(payload)
        }
        if(priceLevel?.getName() !== form.name) {
            PriceLevelService.update(priceLevelIdMatch, form).then(res => {
                if (!isError(res)) {
                    dispatch(updatePriceLevelAction(res))
                } else {
                    setError("price_level.form.edit.update_error")
                }
            })
        }
        if(saveWithRedirect) {
            setShouldRedirect(true)
        } else {
            setShouldRedirect(false)
        }
    }

    const deletePriceLevel = (id: string) => {
        PriceLevelService.delete(id).then(res => {
            if (!isError(res)) {
                setShouldRedirect(true)
            }
        })
    }

    if (shouldRedirect) {
        return <Redirect to="/priceLevels/catalog" />
    }

    return (
        <>
            <PriceLevelForm
                priceLevel={priceLevel}
                error={error}
                onDeleteCallback={deletePriceLevel}
                onUpdateCallback={updatePriceLevel}
            ></PriceLevelForm>
        </>
    )
}

export default injectIntl(EditPriceLevelComponent)



// WEBPACK FOOTER //
// ./src/product/price-level/components/EditPriceLevelComponent.tsx